var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalTransactionsAmount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.794,
    height: 20.854,
    viewBox: "0 0 19.794 20.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_Transactions_Amount",
    "data-name": "Total Transactions Amount",
    transform: "translate(0.756 0.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17639",
    "data-name": "Path 17639",
    d: "M1.062-9.717q.269.017.558.017a3.7,3.7,0,0,0,.566-.043,2.54,2.54,0,0,0,.529-.14,1.543,1.543,0,0,0,.452-.269,1.345,1.345,0,0,0,.329-.432,1.783,1.783,0,0,0,.163-.626H.816a1.89,1.89,0,0,1,.094-.169l.163-.272q.1-.166.229-.36H3.516a.445.445,0,0,0-.143-.3,1.571,1.571,0,0,0-.346-.272,2.49,2.49,0,0,0-.415-.2,1.067,1.067,0,0,0-.349-.077H.816a1.343,1.343,0,0,1,.1-.206q.077-.137.163-.272l.152-.237a.65.65,0,0,1,.071-.1H6.066l-.031.063q-.031.063-.083.152l-.114.194-.117.2q-.054.091-.092.152l-.037.06H4.339a3.67,3.67,0,0,1,.209.415,1.487,1.487,0,0,1,.112.432H6.066l-.475.8H4.711a2.276,2.276,0,0,1-.3.909,2.211,2.211,0,0,1-.566.626,2.585,2.585,0,0,1-.746.383,4.382,4.382,0,0,1-.846.186.141.141,0,0,0,.02.037q.02.031.049.071a1.169,1.169,0,0,0,.069.1L4.928-5.394v.143H3.842L1.062-8.963Z",
    transform: "translate(6.169 19.303)",
    fill: "#6d44e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17640",
    "data-name": "Path 17640",
    d: "M19.259,11.357A9.179,9.179,0,0,0,1.624,6.822M1.05,2.233V6.822H5.639",
    transform: "translate(-1.05 -1.04)",
    fill: "none",
    stroke: "#6d44e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18360",
    "data-name": "Path 18360",
    d: "M19.259,11.357A9.179,9.179,0,0,0,1.624,6.822M1.05,2.233V6.822H5.639",
    transform: "translate(19.331 20.357) rotate(180)",
    fill: "none",
    stroke: "#6d44e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTransactionsAmount);
export default __webpack_public_path__ + "static/media/Total_Transactions_Amount.d088704774bdf32bdbda8735848186d0.svg";
export { ForwardRef as ReactComponent };